import { render, staticRenderFns } from "./PageNavbar.vue?vue&type=template&id=2875f00c&"
import script from "./PageNavbar.vue?vue&type=script&lang=js&"
export * from "./PageNavbar.vue?vue&type=script&lang=js&"
import style0 from "./PageNavbar.vue?vue&type=style&index=0&id=2875f00c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports